/** @jsx jsx */
import React from 'react';
import { navPlatformSidebarResource } from '@jira/nav-platform-integration__resources/src/navPlatformSidebarResource.tsx';
import {
	getNav4SidebarId,
	useGetParamsForGetNav4SidebarId,
} from '@jira/navigation-apps__sidebar-nav4-sidebar-selector/src/common/logic.tsx';
import { jsx } from '@atlaskit/css';
import { useSuspenseResource } from '@atlassian/react-resource-router/src/resources/controllers/use-resource/suspense.tsx';
import { GSNForOtherSidebars } from './GSNForOtherSidebars.tsx';
import { GSNForContentSidebar } from './GSNForContentSidebarEntryPoint.tsx';

/**
 * GlobalSideNavigationSidebarSelector is the sidebar-selector for non-EP routes.
 *
 * If a route is not using entrypoints, this component will be rendered, and
 * it has to determine which sidebar to show.
 *
 * If a route IS using entrypoints, the correct sidebar to load can be specified
 * in the route config (via `entryPoint: () => someEPConfig`). In this case, we
 * don't need to render this component at all.
 *
 * The parent component (NavPlatformSidebar) is responsible for deciding which
 * code path to take (the EP or non-EP code path).
 */

export function GlobalSideNavigationSidebarSelector(): React.JSX.Element | null {
	const { data } = useSuspenseResource(navPlatformSidebarResource);
	const sidebarId = getNav4SidebarId(useGetParamsForGetNav4SidebarId());

	if (sidebarId === 'CONTENT') {
		return <GSNForContentSidebar queryReference={data} />;
	}

	return <GSNForOtherSidebars queryReference={data} />;
}
